import { render, staticRenderFns } from "./MovimientosCRUD.vue?vue&type=template&id=0616856b"
import script from "./MovimientosCRUD.vue?vue&type=script&lang=js"
export * from "./MovimientosCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports